/* CONSTANTS & VARIABLES --------------------------------------------------------------------------------------------------------------------------------------------------------- */

const isProduct = window.location.pathname.includes("/products/");
const isCart = window.location.pathname.includes("/cart");
const isEFA = isProduct && product.tags && product.tags.includes("EFA");

if (!userPreferences){
  const userPreferences = JSON.parse(
    localStorage.getItem("sb-user-preferences")
  ) || {
    deliveryMethod: null,
    store: {
      name: null,
      storePrefix: null,
      erBranchId: null,
    },
    zipcode: null,
  };
}

if (!userPreferences.store)
  userPreferences.store = {
    name: null,
    storePrefix: null,
    erBranchId: null,
  };

if (!userPreferences.zipcode) userPreferences.zipcode = null;

/* LISTENERS --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */

// on page ready, remove loading class
$(document).ready(() => {
  if (isProduct) {
    autofillUserPreferences().then(() => {
      if (isRental) {
        openFirstIncompleteStep();
        const autofilledMethod = userPreferences.deliveryMethod === "pickup" ? `Pick up at ${userPreferences.store.name || ""}`
          : userPreferences.deliveryMethod === "doordash" ? `DoorDash to ${userPreferences.zipcode || ""}`
          : userPreferences.deliveryMethod === "ship" ? "Ship to you" 
          : "";
        updateDatePicker(autofilledMethod);
      }
    });
  }
  $(".delivery-method-tile.loading").removeClass("loading");
});

// listen for primary selection
$(".delivery-method-tile--primary").on("click", (e) =>
  handleDeliveryMethodTileSelection(e.target.closest(".delivery-method-tile"))
);

// listen for store selection
$('[name="secondary-selector--store"]').on("change", (e) => {
  //  console.log("store selected", e.target.value);

  // get necessary elements
  const group = e.target.closest(".delivery-method-tiles--wrapper");
  const tile = e.target.closest(".delivery-method-tile");
  const isRental = group.classList.contains("rental");

  // update tile data
  tile.setAttribute("data-value", `Pick up at ${e.target.value}`);
  if (tile.dataset.value) {
    tile.querySelector(
      ".delivery-method-tile--title"
    ).innerHTML = `<div>Pick up at <a>${e.target.value}</a></div>`;
    // console.log("e.target.dataset", e.target.dataset);
    const storeInstock = e.target.dataset?.storeInstock === 'true' ? true : false;
     updatePickupTimingDisplay(tile, storeInstock, product.tags.includes('PREORDER'));
  }
  setDeliveryMethodValue(group, tile.dataset.value).then((deliveryMethodSet) => {
      if (isRental) {
        updateDatePicker(tile.dataset.value);
      } else {
        addToBagButton.disabled = !deliveryMethodSet;
        addToBagButton.setAttribute("aria-disabled", !deliveryMethodSet ? "true" : "false");
      }
  }); // set delivery method

  // update user preferences
  userPreferences.store.name = e.target.value;
  userPreferences.store.storePrefix = e.target.dataset.storePrefix;
  userPreferences.store.erBranchId = e.target.dataset.erBranchId;
  localStorage.setItem("sb-user-preferences", JSON.stringify(userPreferences));

  if (isRental) {
    const step = group.closest(".rental-step");
    stepComplete(step)
      ? updateStepStatus(step, true)
      : updateStepStatus(step, false);
  }
});

// listen for doordash zipcode input
const zipcodeInputs = document.querySelectorAll("input.delivery-method-zip-code");
zipcodeInputs.forEach((input) => {
  input.addEventListener("input", (e) => {
    // console.log("zipcode input", e.target.value);
    zipcodeInputs.forEach((zipInput) => {
      zipInput.value = e.target.value.slice(0, 5);
    });
    const group = e.target.closest(".delivery-method-tiles--wrapper");
    handleDeliveryZipcodeInput(e.target);
  });
});

// listen for delivery method change request
$(".delivery-method-change-request-link").on("click", (e) => {
  e.preventDefault();
  e.target
    .closest(".delivery-method-tiles--wrapper")
    .classList.toggle("changing");
});

/* FUNCTIONS --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */

async function autofillUserPreferences() {
  if (!isProduct || !userPreferences || isEFA) return;
  const cart = await getCart();
  const autofillGroup = document.querySelector(
    ".delivery-method-tiles--wrapper"
  );

  // check for no pickup store selected
  const storePrefix = userPreferences.store?.storePrefix;
  if (userPreferences.deliveryMethod == 'pickup' && storePrefix && product?.tags?.includes(`NOPICKUP-${storePrefix}`)) {
    return false;
  }

  const autofillMethod =
    cart.attributes["Rental Delivery Method"] 
    ? cart.attributes["Rental Delivery Method"]
      : userPreferences.deliveryMethod === "pickup" && userPreferences.store && userPreferences.store.name
      ? `Pick up at ${userPreferences.store.name}`
      : userPreferences.deliveryMethod === "doordash" && userPreferences.zipcode
      ? `DoorDash to ${userPreferences.zipcode}`
      : userPreferences.deliveryMethod === "ship"
      ? `Ship to you`
      : null;

  if (!autofillMethod) return;

  const prefferedStoreName = autofillMethod.includes("Pick up")
    ? autofillMethod.replace("Pick up at ", "")
    : userPreferences && userPreferences.store
    ? userPreferences.store.name
    : null;

  const preferredStore = prefferedStoreName
    ? stores.find((store) => store.name === userPreferences.store.name)
    : null;

  if (autofillMethod.includes("Pick up") && preferredStore) updateStoresAvailability();

  const autofillMethodAvailable =
    autofillMethod.includes("Pick up") && preferredStore
      ? preferredStore.pickup
      : true;

  if (!autofillMethodAvailable) return;

  // autofill delivery method tiles
  setDeliveryMethodValue(autofillGroup, autofillMethod).then((deliveryMethodSet) => {
      if (isRental) {
        updateDatePicker(autofillMethod);
      } else {
        addToBagButton.disabled = !deliveryMethodSet;
        addToBagButton.setAttribute("aria-disabled", !deliveryMethodSet ? "true" : "false");
      }
  });

  // prefill prefered store
  if (userPreferences.store && userPreferences.store.name) {
    autofillGroup
      .querySelector(
        `[name="secondary-selector--store"][value="${userPreferences.store.name}"]`
      )
      ?.setAttribute("checked", "true");
    autofillGroup
      .querySelector('.delivery-method-tile[data-method="pickup"]')
      ?.setAttribute("data-value", `Pick up at ${userPreferences.store.name}`);
    const pickupTileTitle = autofillGroup.querySelector('.delivery-method-tile[data-method="pickup"] .delivery-method-tile--title')
    if (pickupTileTitle) {
      pickupTileTitle.innerHTML = `<div>Pick up at <a>${userPreferences.store.name}</a></div>`;
    }
  }

  if (isRental) {
    // validate rental form
    setTimeout(
      () => {
        addToBagButton.disabled = rentalFormValid() && !addToBagButton.classList.contains("locked") ? false: true;
        addToBagButton.setAttribute("aria-disabled", rentalFormValid() && !addToBagButton.classList.contains("locked") ? "false" : "true");
      },
      500
    );
  }
}

async function getSameDayAvailability(articleNumber, zipcode) {
  if (!articleNumber || !zipcode) return false;
  const samedayStores = getDoorDashStores(zipcode);
  const storeAvailability = await getStoreAvailability(articleNumber);
  console.log('storeAvailability', storeAvailability) ;
  const storesWithInventory = await getAvailableStores(articleNumber); // get stores with inventory for this article
  console.log("storesWithInventory", storesWithInventory);
  console.log("samedayStores", samedayStores);
  const samedayStoresWithInventory = samedayStores.filter(
    (store) =>
      storesWithInventory.includes(store.name) ||
      storesWithInventory.includes(store.short_name)
  );
  // console.log("samedayStoresWithInventory", samedayStoresWithInventory, samedayStoresWithInventory.length > 0);
  if (samedayStoresWithInventory.length > 0) return true;
  return false;
}

function getSameDayAvailabilityRentals(zipcode) {
  if (!zipcode) return false;

  // get stores within DoorDash range of this zipcode
  const doordashStores = getDoorDashStores(zipcode);
  if (!doordashStores || doordashStores.length === 0) return false;

  // get stores tagged for no pickup
  const noPickupStores = product.tags
    .filter((tag) => tag.startsWith("NOPICKUP-"))
    .map((tag) => tag.replace("NOPICKUP-", ""));

  // remove any no-pickup stores from available DoorDash stores
  doordashStores.forEach((store) => {
    if (noPickupStores.includes(store.store_prefix)) {
      const index = doordashStores.indexOf(store);
      if (index !== -1) doordashStores.splice(index, 1);
    }
  });

  if (!doordashStores || doordashStores.length === 0) return false;
  return doordashStores;
}

function getDoorDashStores(zipcode) {
  // pointing retail products at rental zip codes as of 2024-10-31 per Anthony
  if (!zipcode) return false;
  const doorDashStores = [...stores];
  // console.log("doorDashStores", doorDashStores);
  // filter door dash stores by zipcode in doordash_zipcodes_rental
  const availableDoorDashStores = doorDashStores.filter((store) => {
    const isAvailable = !store.omit_from_delivery_method_tiles && store.doordash_zipcodes_retail && store.doordash_zipcodes_retail.includes(Number(zipcode));
    return isAvailable;
  });
  // console.log("availableDoorDashStores", zipcode, availableDoorDashStores);
  return availableDoorDashStores;
}

function getSelectedVariant() {
  const selectedVariantId = document.querySelector('[name="id"]').value;
  return product.variants.find(
    (variant) => variant.id === Number(selectedVariantId)
  );
}

async function handleDeliveryMethodTileSelection(tile) {
  if (!tile) return; // abort if no tile is found
  if (tile.classList.contains("loading")) return; // abort if still loading

  document
    .querySelectorAll(".delivery-method-tile--secondary")
    .forEach((t) => t.classList.remove("open")); // close all secondary selection drawers

  const group = tile.closest(".delivery-method-tiles--wrapper"); // get tile group
  const tileSelected = tile.classList.contains("selected"); // check if tile is selected
  const deliveryMethod = tile.dataset.value || null; // get tile delivery method value
  const secondarySelectionDrawer =
    tile.querySelector(".delivery-method-tile--secondary") || null; // get secondary selection drawer

  updateStoresAvailability();


  if (tileSelected && secondarySelectionDrawer)
    secondarySelectionDrawer.classList.toggle("open");
  if (!tileSelected) {
    group
      .querySelectorAll(".delivery-method-tile")
      .forEach((t) => t.classList.remove("selected")); // clear any previous selection
    if (deliveryMethod) {
      tile.classList.add("selected"); // mark tile as selected
    } else if (!tileSelected && !deliveryMethod && secondarySelectionDrawer) {
      secondarySelectionDrawer.classList.toggle("open"); // toggle secondary selection drawer
    }
    setDeliveryMethodValue(group, deliveryMethod).then((deliveryMethodSet) => {
      if (isRental) {
        updateDatePicker(deliveryMethod);
      } else {
        addToBagButton.disabled = !deliveryMethodSet;
        addToBagButton.setAttribute("aria-disabled", !deliveryMethodSet ? "true" : "false");
      }
    }); // set delivery method
  }

  // check store availability, if necessary
  if (
    secondarySelectionDrawer &&
    secondarySelectionDrawer.classList.contains("open") &&
    tile.dataset.method === "pickup"
  )
    
  // update user preferences
  userPreferences.deliveryMethod = tile.dataset.method;
  // console.log("userPreferences.deliveryMethod", userPreferences.deliveryMethod);
  localStorage.setItem("sb-user-preferences", JSON.stringify(userPreferences));
}

async function handleDeliveryZipcodeInput(input) {
  // console.log("handleDeliveryZipcodeInput", input.value);
  if (!input) return;

  /* 
    1. sanitize input
      - disallow non-numbers
      - limit to 5 characters
      - if shorter than 5 characters ...
        - reset shipping estimate
        - reset DoorDash status
        - if delivery method is not shipping, unset delivery method
        - exit function
    3. update zipcode in user preferences
    4. fetch shipping estimate from API and update shipping title display
    5. validate DoorDash zipcode from API and update DoorDash status display
    6. if method is DoorDash ...
      - if rental product, set rental branch id based on zipcode
      - if DoorDash available for ZIP code, set delivery method to DoorDash to [zipcode]
      - if not available, unset delivery method
  */

  // get necessary variables
  const zipcode = input.value;
  const method = input.dataset.method;
  const group = input.closest(".delivery-method-tiles--wrapper");
  const isRental = group.classList.contains("rental");

  // handle error cases
  if (!zipcode || !group || !method || (method !== "ship" && method !== "doordash")) return;

  // sanitize input
  input.value = input.value.replace(/[^0-9]/g, ""); // disallow non-numbers
  input.value = input.value.slice(0, 5); // limit to 5 characters

  // if zipcode is shorter than 5 characters, reset displays and exit function
  if (input.value.length !== 5) {
    setShippingEstimateDisplay(null, null); // reset shipping estimate
    setDoorDashStatusDisplay(null, false); // reset DoorDash status
    const currentDeliveryMethod = group.querySelector(".delivery-method-tiles--property-input").value || null; // get current delivery method value
    if (currentDeliveryMethod && !currentDeliveryMethod.toLowerCase().includes("ship")) setDeliveryMethodValue(group, null).then((deliveryMethodSet) => {
      if (isRental) {
        updateDatePicker(currentDeliveryMethod);
      } else {
        addToBagButton.disabled = !deliveryMethodSet;
        addToBagButton.setAttribute("aria-disabled", !deliveryMethodSet ? "true" : "false");
      }
    }); // unset delivery method, if not shipping
    return false;
  }

  // update zipcode in user preferences
  userPreferences.zipcode = zipcode;
  localStorage.setItem("sb-user-preferences", JSON.stringify(userPreferences));

  // fetch shipping estimate and update shipping title display
  const estimatedArrivalDate = await getShippingEstimate(zipcode) || null;
  setShippingEstimateDisplay(zipcode, estimatedArrivalDate, group);

  // fetch DoorDash availability and update DoorDash status display
  const doordashAvailable = await validateDoorDashZipcodeInput(zipcode, group);

  // if ZIP code method is DoorDash, validate zipcode and update display
  if (method === "doordash") {
    // set rental branch id if rental
    if (isRental) {
      const rentalDoorDashStores = stores.filter((store) => !store.omit_from_delivery_method_tiles && store.doordash_zipcodes_rental.includes(Number(input.value)));
      input.dataset.erBranchId = rentalDoorDashStores.length > 0 ? rentalDoorDashStores[0].easyrent_branch_id : "";
    }
  }

  // set delivery method value based on availability
  const deliveryMethodTitleText = method === "doordash" && doordashAvailable 
    ? `DoorDash to ${input.value}` 
    : method === "ship" ? "Ship to you" 
    : null;
  setDeliveryMethodValue(group, deliveryMethodTitleText).then((deliveryMethodSet) => {
      if (isRental) {
        updateDatePicker(deliveryMethodTitleText);
      } else {
        addToBagButton.disabled = !deliveryMethodSet;
        addToBagButton.setAttribute("aria-disabled", !deliveryMethodSet ? "true" : "false");
      }
  }); // set delivery method

}

async function getShippingEstimate(toZipcode, fromZipcode = "94129") {
  const apiUrl = `https://inventory.sportsbasement.com/ups/time-in-transit?toZip=${toZipcode}&fromZip=${fromZipcode}`;
  const shippingZipcodeInput = document.querySelector('input[name="shipping-zip-code"]');
  const shippingEstimateStatusElement = document.querySelector(".delivery-method-tiles--wrapper .shipping-estimate-status");
  if (!shippingZipcodeInput || !shippingEstimateStatusElement) return false;
  try {
    const response = await fetch(apiUrl);
    const data = await response.json();
    // console.log("Shipping estimate data:", data);

    // handle invalid zipcode response
    if (!data || !data.adjustedDeliveryDate) {
      shippingZipcodeInput.classList.add("error");
      // console.log("Invalid ZIP code for shipping estimate:", toZipcode);
      return;
    }

    // handle valid zipcode response
    shippingZipcodeInput.classList.remove("error");
    if (data && data.emsResponse.destinationStateProvince === "AK" || data.emsResponse.destinationStateProvince === "HI") {
      shippingEstimateStatusElement.innerText = "Shipping not available to Alaska & Hawaii.";
      shippingEstimateStatusElement.classList.add("text-sb-red", "font-semibold");
    } else if (data && data.adjustedDeliveryDate) {
      // add rental lead time if applicable
      if (product?.dateTimeData?.minDates?.shipping) {
        const shippingDate = new Date(data.adjustedDeliveryDate);
          const minShippingDate = new Date(product.dateTimeData.minDates.shipping);
          const finalDeliveryDate = shippingDate > minShippingDate 
            ? data.adjustedDeliveryDate 
            : product.dateTimeData.minDates.shipping;
          return finalDeliveryDate;
      }
      // if not rental, return estimated delivery date
      console.log(`${apiUrl} says ${data.adjustedDeliveryDate}`)
      return data.adjustedDeliveryDate;
    } else {
      return;
    }
  } catch (error) {
    console.error("Error fetching shipping estimate:", error);
    return false;
  }
}

function setShippingEstimateDisplay(zipcode, date, group ) {
  group = group || document.querySelector(".delivery-method-tiles--wrapper");
  const shippingTitle = group.querySelector(`.delivery-method-tile[data-method="ship"] .delivery-method-tile--title`);
  if (!shippingTitle) return;
  const dateString = date ? formatToLongDate(date) : null;
  shippingTitle.innerHTML = !zipcode || !dateString || product.tags.includes("PREORDER")
    ? "Ship To You" 
    : `<div>Ships to <span class="text-sb-green hover:underline">${zipcode}</span> <span class="font-normal">by ${dateString}</span></div>`;

  if (!zipcode) {
    group.querySelector(`.shipping-estimate-status`).innerText = product.tags.includes("PREORDER") ? "Ships as soon as product arrives in our stores." : "Enter your ZIP code for delivery estimate";
    group.querySelector(`.shipping-estimate-status`).classList.remove("text-sb-red", "text-sb-green", "font-semibold");
  }
}

function setDoorDashStatusDisplay(zipcode, available, group) {
  // get necessary elements
  group = group || document.querySelector(".delivery-method-tiles--wrapper");
  const doordashTile = group.querySelector(`.delivery-method-tile[data-method="doordash"]`);
  const doordashTitle = doordashTile.querySelector(`.delivery-method-tile--title`);

  // update doordash title
  const zipcodeColor = available ? "text-sb-green" : "text-sb-red";
  doordashTitle.innerHTML = !zipcode || zipcode === null || zipcode === undefined
    ? `Same Day Delivery via <img src="https://cdn.shopify.com/s/files/1/0751/7203/files/doordash-horizontal_x15.png?v=1758664378" alt="DoorDash" display:inline;="" margin-left:0.25rem;="" margin-bottom:0.125rem;"="">`
    : `<div>DoorDash to <span class="${zipcodeColor} hover:underline">${zipcode}</span></div>`;

  // update doordash availability status message
  const zipCodeStatus = group.querySelector(".zip-code-status"); // get zip code status element
  const zipcodeStatusIcon = available
    ? "sb-icon-success"
    : "sb-icon-cancel";
  const zipcodeStatusText = available
    ? "Order by 3pm for delivery today"
    : "Oh no! The selected product is currently unavailable for delivery in this ZIP code.";
  doordashTile.dataset.value = available ? `DoorDash to ${zipcode}` : "";
  zipCodeStatus.innerHTML = `<span class="${zipcodeColor} flex gap-2 items-center"><i class="${zipcodeStatusIcon}"></i><span>${zipcodeStatusText}</span></span>`;
  // doordashTitle.innerHTML = `<div>DoorDash to <span class="${zipcodeColor}">${zipcode}</span></div>`;
}

async function validateDoorDashZipcodeInput(zipcode, group) {
  if (!zipcode || zipcode.length !== 5) {
    setDoorDashStatusDisplay(false, false, group);
    return;
  }

  try {
    const tile = group.querySelector(
      `.delivery-method-tile[data-method="doordash"]`
    ); // get parent tile
    const zipCodeStatus = group.querySelector(".zip-code-status"); // get zip code status element
    
    zipCodeStatus.innerHTML = "Checking availability..."; // loading status
    const selectedArticle = isProduct
      ? $("#article-number").text().replace("Article #", "").trim()
      : isCart
      ? group.dataset.article
      : undefined; // get article number

    // check article availability for this zip code
    const isAvailable =
      isCart && group.classList.contains("rental")
        ? await getSameDayAvailabilityRentals(zipcode)
        : isCart && !group.classList.contains("rental")
        ? await getSameDayAvailability(selectedArticle, zipcode)
        : isRental
        ? await getSameDayAvailabilityRentals(zipcode)
        : await getSameDayAvailability(selectedArticle, zipcode);

    setDoorDashStatusDisplay(zipcode, isAvailable, group); // update status display
    userPreferences.zipcode = zipcode; // update user preferences
    localStorage.setItem("sb-user-preferences", JSON.stringify(userPreferences)); // save to local storage
    return isAvailable;
  } catch (error) {
    console.error(error);
  }
  return false;
}

async function setDeliveryMethodValue(group, deliveryMethod) {
  // handle missing group
  if (!group) {
    return false
  };

  // get necessary elements
  const deliveryMethodPropertyInput = group.querySelector(`.delivery-method-tiles--property-input`);
  const deliveryMethodAttributeInput = group.querySelector(`input[name="attributes[Rental Delivery Method]"]`);

  // clear previous selection
  group
    .querySelectorAll(".delivery-method-tile")
    .forEach((t) => t.classList.remove("selected")); 

  // handle no delivery method
  if (!deliveryMethod) {
    if (deliveryMethodPropertyInput) deliveryMethodPropertyInput.value = "";
    if (deliveryMethodAttributeInput) deliveryMethodAttributeInput.value = "";
    addToBagButton.disabled = true; // disable add to cart button
    addToBagButton.setAttribute("aria-disabled", "true");
    return;
  }

  // get delivery method type
  const deliveryMethodType = deliveryMethod.includes("Pick up")
    ? "pickup"
    : deliveryMethod.includes("DoorDash")
    ? "doordash"
    : deliveryMethod.includes("Ship")
    ? "ship"
    : null;

  // handle delivery method type error
  if (!deliveryMethodType) {
    return false;
  }

  // save user preference
  userPreferences.deliveryMethod = deliveryMethodType;
  localStorage.setItem("sb-user-preferences", JSON.stringify(userPreferences));
  
  // set group data-method
  group.dataset.method = deliveryMethodType;

  // mark appropriate tile as selected
  const selectedMethodTile = group.querySelector(`.delivery-method-tile[data-method="${deliveryMethodType}"]`);

  // handle no matching tile found
  if (!selectedMethodTile) {
    return false;
  }

  // don't select hidden tiles (e.g. DoorDash hidden for presale variants)
  if (selectedMethodTile.classList.contains('hidden')) {
    return false;
  }

  // mark tile as selected
  selectedMethodTile.classList.add("selected");

  // handle delivery method type specific actions
  if (deliveryMethodType === "ship") {
    // mark ship tile as selected
    deliveryMethodPropertyInput.value = deliveryMethod;
    if (deliveryMethodAttributeInput)
      deliveryMethodAttributeInput.value = deliveryMethod;
  } else if (deliveryMethodType === "pickup") {
    // mark appropriate store as selected, if applicable
    const storeName = deliveryMethod.replace("Pick up at ", "");
    const storeSelector = group.querySelector(
      `[name="secondary-selector--store"][value="${storeName}"]`
    );
    if (storeSelector) storeSelector.setAttribute("checked", "true");
    deliveryMethodPropertyInput.value = deliveryMethod;
    if (deliveryMethodAttributeInput)
      deliveryMethodAttributeInput.value = deliveryMethod;
  } else if (deliveryMethodType === "doordash") {
    // set DoorDash zipcode, if applicable
    const zipcode = deliveryMethod.replace("DoorDash to ", "");
    const zipCodeInput = group.querySelector('[name="doordash-zip-code"]');
    if (zipCodeInput) zipCodeInput.value = zipcode;
    validateDoorDashZipcodeInput(zipcode, group).then((valid) => {
      if (valid) {
        deliveryMethodPropertyInput.value = deliveryMethod;
        if (deliveryMethodAttributeInput)
          deliveryMethodAttributeInput.value = deliveryMethod;
      } else {
        deliveryMethodPropertyInput.value = "";
        if (deliveryMethodAttributeInput)
          deliveryMethodAttributeInput.value = "";
      }
    });
  }

  // handle rental products
  if (isProduct && isRental) updateDatePicker(deliveryMethod);

  // close open secondary selection drawers
  group.querySelectorAll(".delivery-method-tile--secondary.open").forEach((t) => {
    const drawerDelay = deliveryMethodType === "doordash" ? 1500 : 250; // delay for pickup method
    setTimeout(() => t.classList.remove("open"), drawerDelay);
  });

  // handle cart updates
  if (isCart) {
  
    group.classList.remove("changing"); // close delivery method change request drawer
    const lineItems = document.querySelectorAll("[data-line-item-key]");
    const lineItemKeys = Array.from(lineItems).map(item => item.getAttribute("data-line-item-key"));
    const lineItemKey = group.dataset.lineItemKey;
    if (lineItemKey) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: lineItemKey,
          properties: {
            "Delivery Method": deliveryMethod,
          },
        }),
      })
        .then((response) => response.json())
        .then(async (data) => {
          // update line item key in DOM
          const newLineItemKeys = Array.from(data.items).map(item => item.key);
          const addedLineItemKey = newLineItemKeys.filter(key => !lineItemKeys.includes(key))[0];
          const removedLineItemKey = lineItemKeys.filter(key => !newLineItemKeys.includes(key))[0];
          const lineItemUpdates = document.querySelectorAll(`[data-line-item-key="${removedLineItemKey}"]`);
          if (lineItemUpdates.length) lineItemUpdates.forEach(item => {
            item.dataset.lineItemKey = addedLineItemKey;
          })
          // update delivery methods display
          updateCart(data);
        })
        .catch((error) => {
          console.error("Error updating cart:", error);
          location.reload(); // reload page on error
        });
    }
  }

  return true;
}

function updatePickupTimingDisplay(tile, available, preorder = false) {
  if (!tile || tile.dataset.method !== "pickup") return;
  const titleElement = tile.querySelector(".delivery-method-tile--title");
  const storeName = titleElement.querySelector("a").innerText;
  titleElement.innerHTML = isRental ? `<div>Pick up at <a>${storeName}</a></div>`
    : preorder ? `<div>Pick up at <a>${storeName}</a></div>`
    : `<div>Pick up at <a>${storeName}</a> <span class="font-normal">Within ${available ? '1 hour' : '3 days'}</span></div>`;
}

// update store availability in delivery method tiles
function updateStoresAvailability(articleNumber, tileGroup) {
  articleNumber = articleNumber
    ? articleNumber
    : $("#article-number").text().replace("Article #", "").trim();
  if (!articleNumber) return;

  getStoreAvailability(articleNumber).then((storeAvailability) => {
    console.log('storeAvailability', storeAvailability)
    // update store status elements
    // const store_status_elements = tileGroup
    //   ? tileGroup.querySelectorAll(".secondary-selector--store")
    //   : document.querySelectorAll(".secondary-selector--store");
    // store_status_elements.forEach((e) => {
    //   console.log('e', e)
    //   const store_name = e.getAttribute("data-store");
    //   const store = storeAvailability.find(
    //     (s) => s.name === store_name || s.short_name === store_name
    //   );
    //   let instock = "false";
    //   if (store?.available) instock = store.low_inventory ? "low" : "true";
    //   e.setAttribute("data-store-instock", instock);
    // });

    // update store selector buttons
    const store_selectors = tileGroup
      ? tileGroup.querySelectorAll("[data-store-name]")
      : document.querySelectorAll("[data-store-name]");
    store_selectors.forEach((selector) => {
      const store_name = selector.getAttribute("data-store-name");
      const store = storeAvailability.find((s) => s.name === store_name || s.short_name === store_name);
      selector.dataset.storeInstock = store.available;
      selector.dataset.storeLowInventory = store.low_inventory;
      const selector_parent = selector.closest(".store-pickup-tile");
      if (selector_parent)
        selector_parent.setAttribute("data-store-instock", store.available);

      if (selector.checked) {
        selector
          .closest(".delivery-method-tile")
          .setAttribute("data-store-instock", store.available);
        updatePickupTimingDisplay(
          selector.closest(".delivery-method-tile"),
          store.available,
          product.tags.includes('PREORDER')
        );
      }
    });
  });
}
